// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1246":"1ed47d19","1819":"1ed47d19","4015":"1ed47d19","7351":"1ed47d19","7723":"1ed47d19"}[chunkId] + ".chunk.css";
};